export default "__VITE_ASSET__CiCxVpNE__"